export const MAX_ATTEMPTS_REACHED_ERROR_CODE = 'max_attempts_reached';
export const INCORRECT_CODE = 'incorrect_code';
export const LOG_TAG_ACCOUNT_DETAILS_UPDATE = '[Account Details Update]';
